// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autosuggest-list__no-results_14718fa5.autosuggest-list__no-results_14718fa5,
.autosuggest-list__caption_14718fa5.autosuggest-list__caption_14718fa5 {
  background-color: #f8f9fa;
  cursor: unset;
}
.autosuggest-list__caption_14718fa5.autosuggest-list__caption_14718fa5 {
  font-weight: 600;
  text-transform: uppercase;
  border-color: #dce1e5;
  border-type: solid;
  border-width: 1px 0 1px 0;
  top: -0.334rem;
  z-index: 1;
  position: sticky;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autosuggest-list__no-results": `autosuggest-list__no-results_14718fa5`,
	"autosuggest-list__caption": `autosuggest-list__caption_14718fa5`
};
export default ___CSS_LOADER_EXPORT___;
